export default {
  orsLPolyline: {
    type: 'Tip',
    surface: 'Suprafața',
    unknownSurfaceType: 'Necunoscut',
  }
}
